export default function naturalSort(a, b, key = null, direction = 'DESC') {
  const valA = key ? a[key] : a;
  const valB = key ? b[key] : b;

  let result = 0;
  if (typeof valA === 'number') {
    result = valB - valA;
  } else {
    result = `${valB}`.localeCompare(`${valA}`, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }

  return direction === 'DESC' ? result : result * -1;
}
